import React from "react"
import { graphql } from "gatsby"
import { ModalRoutingContext } from "gatsby-plugin-modal-routing"
import ReactMarkdownWithHtml from "react-markdown/with-html"
import style from "./speaker.module.scss"
import Layout from "../../components/layout"
import Modal from "../../components/modal"
import SEO from "../../components/seo"

const share = (title, desciption, url) => {
  const shareData = {
    title: title,
    text: desciption,
    url: url,
  }
  try {
    navigator.share(shareData)
    return true
  } catch (ex) {
    return false
  }
}

const Section = props => {
  if (props.data.allStrapiSpeaker.nodes.length === 0) {
    return <div />
  }
  const section = props.data.allStrapiSpeaker.nodes[0].sessions.length
    ? props.data.allStrapiSpeaker.nodes[0].sessions[0]
    : null
  const speaker = props.data.allStrapiSpeaker.nodes[0]
  const startTime = section ? new Date(section.start_time) : null
  const endTime = section ? new Date(section.end_time) : null
  const content = (
    <div className={style.content}>
      <div className={style.label}>介紹</div>
      <ReactMarkdownWithHtml
        allowDangerousHtml={true}
        children={speaker.description}
      ></ReactMarkdownWithHtml>
      {section && (
        <>
          <div className={style.label}>議程主題</div>
          <div
            style={{ fontWeight: 600 }}
            dangerouslySetInnerHTML={{
              __html:
                section.name &&
                section.name.replace(/(?:\r\n|\r|\n)/g, "<br/>"),
            }}
          ></div>
          <div style={{ fontWeight: 600, margin: "0.5rem 0" }}>
            <svg
              width="18px"
              height="19px"
              viewBox="0 0 18 19"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              style={{ verticalAlign: "top" }}
            >
              <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
              >
                <g
                  id="議程_web"
                  transform="translate(-373.000000, -490.000000)"
                  fillRule="nonzero"
                >
                  <g
                    id="fa-calendar-o"
                    transform="translate(373.000000, 490.000000)"
                  >
                    <g id="Icon" fill="#000000">
                      <path
                        d="M1.38461538,17.6428571 L16.6153846,17.6428571 L16.6153846,6.78571429 L1.38461538,6.78571429 L1.38461538,17.6428571 Z M5.53846154,4.75 L5.53846154,1.69642857 C5.53846154,1.59747024 5.50600962,1.51618304 5.44110577,1.45256696 C5.37620192,1.38895089 5.29326923,1.35714286 5.19230769,1.35714286 L4.5,1.35714286 C4.39903846,1.35714286 4.31610577,1.38895089 4.25120192,1.45256696 C4.18629808,1.51618304 4.15384615,1.59747024 4.15384615,1.69642857 L4.15384615,4.75 C4.15384615,4.84895833 4.18629808,4.93024554 4.25120192,4.99386161 C4.31610577,5.05747768 4.39903846,5.08928571 4.5,5.08928571 L5.19230769,5.08928571 C5.29326923,5.08928571 5.37620192,5.05747768 5.44110577,4.99386161 C5.50600962,4.93024554 5.53846154,4.84895833 5.53846154,4.75 Z M13.8461538,4.75 L13.8461538,1.69642857 C13.8461538,1.59747024 13.8137019,1.51618304 13.7487981,1.45256696 C13.6838942,1.38895089 13.6009615,1.35714286 13.5,1.35714286 L12.8076923,1.35714286 C12.7067308,1.35714286 12.6237981,1.38895089 12.5588942,1.45256696 C12.4939904,1.51618304 12.4615385,1.59747024 12.4615385,1.69642857 L12.4615385,4.75 C12.4615385,4.84895833 12.4939904,4.93024554 12.5588942,4.99386161 C12.6237981,5.05747768 12.7067308,5.08928571 12.8076923,5.08928571 L13.5,5.08928571 C13.6009615,5.08928571 13.6838942,5.05747768 13.7487981,4.99386161 C13.8137019,4.93024554 13.8461538,4.84895833 13.8461538,4.75 Z M18,4.07142857 L18,17.6428571 C18,18.0104167 17.8629808,18.328497 17.5889423,18.5970982 C17.3149038,18.8656994 16.9903846,19 16.6153846,19 L1.38461538,19 C1.00961538,19 0.685096154,18.8656994 0.411057692,18.5970982 C0.137019231,18.328497 0,18.0104167 0,17.6428571 L0,4.07142857 C0,3.70386905 0.137019231,3.38578869 0.411057692,3.1171875 C0.685096154,2.84858631 1.00961538,2.71428571 1.38461538,2.71428571 L2.76923077,2.71428571 L2.76923077,1.69642857 C2.76923077,1.22991071 2.93870192,0.830543155 3.27764423,0.498325893 C3.61658654,0.166108631 4.02403846,0 4.5,0 L5.19230769,0 C5.66826923,0 6.07572115,0.166108631 6.41466346,0.498325893 C6.75360577,0.830543155 6.92307692,1.22991071 6.92307692,1.69642857 L6.92307692,2.71428571 L11.0769231,2.71428571 L11.0769231,1.69642857 C11.0769231,1.22991071 11.2463942,0.830543155 11.5853365,0.498325893 C11.9242788,0.166108631 12.3317308,0 12.8076923,0 L13.5,0 C13.9759615,0 14.3834135,0.166108631 14.7223558,0.498325893 C15.0612981,0.830543155 15.2307692,1.22991071 15.2307692,1.69642857 L15.2307692,2.71428571 L16.6153846,2.71428571 C16.9903846,2.71428571 17.3149038,2.84858631 17.5889423,3.1171875 C17.8629808,3.38578869 18,3.70386905 18,4.07142857 Z"
                        id="Icon-Shape"
                      ></path>
                    </g>
                    <rect
                      id="ViewBox"
                      x="0"
                      y="0"
                      width="18"
                      height="19"
                    ></rect>
                  </g>
                </g>
              </g>
            </svg>
            {` ${
              startTime.getMonth() + 1
            }/${startTime.getDate()} ${startTime.getHours()}:${startTime
              .getMinutes()
              .toString()
              .padStart(
                2,
                "0"
              )} ~ ${endTime.getHours()}:${endTime
              .getMinutes()
              .toString()
              .padStart(2, "0")} ${section.location}`}
          </div>
          <ReactMarkdownWithHtml
            allowDangerousHtml={true}
            children={section.description}
          ></ReactMarkdownWithHtml>
        </>
      )}

      <div className={style.button}>
        <a
          rel="noreferrer"
          className={"cta"}
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(
            props.data.site.siteMetadata.siteUrl + props.location.pathname
          )}`}
          target="_blank"
          onClick={e => {
            if (
              share(
                section.title,
                section.description,
                props.data.site.siteMetadata.siteUrl + props.location.pathname
              )
            ) {
              e.preventDefault()
            }
          }}
        >
          <svg
            width="23px"
            height="21px"
            viewBox="0 0 23 21"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              id="Page-1"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g
                id="講者_web_pop"
                transform="translate(-527.000000, -937.000000)"
                fillRule="nonzero"
              >
                <g id="Group-18" transform="translate(0.000000, -94.000000)">
                  <g
                    id="fa-solid:share"
                    transform="translate(527.000000, 1030.000000)"
                  >
                    <g
                      id="Icon"
                      transform="translate(0.000000, 1.000000)"
                      fill="#FFFFFF"
                    >
                      <path
                        d="M22.6267441,7.55026325 L14.7203145,0.774437415 C14.028248,0.18127123 12.9375,0.662803584 12.9375,1.58422852 L12.9375,5.15316746 C5.72174414,5.23515413 0,6.67038893 0,13.4569591 C0,16.1961341 1.77805273,18.9097635 3.74347461,20.3285029 C4.35679297,20.7712487 5.23088281,20.2155762 5.00474609,19.4978919 C2.96780859,13.0328932 5.97088086,11.3165676 12.9375,11.2171047 L12.9375,15.1365489 C12.9375,16.0594005 14.0291016,16.5387929 14.7203145,15.94634 L22.6267441,9.16984545 C23.1240742,8.74355044 23.124748,7.97713782 22.6267441,7.55026325 Z"
                        id="Icon-Path"
                      ></path>
                    </g>
                    <rect
                      id="ViewBox"
                      x="0"
                      y="0"
                      width="23"
                      height="23"
                    ></rect>
                  </g>
                </g>
              </g>
            </g>
          </svg>
          分享這位講者
        </a>
      </div>
    </div>
  )

  return (
    <ModalRoutingContext.Consumer>
      {({ modal, closeTo }) => {
        if (modal) {
          return (
            <Modal>
              <div className={[style.sectionWrap, style.modal].join(" ")}>
                <div
                  className={style.head}
                  style={{
                    backgroundImage: "url(/images/header.speaker.svg)",
                  }}
                >
                  <div className={style.speaker}>
                    {speaker.avatar && (
                      <div className={style.avatar}>
                        <img
                          src={speaker.avatar.childImageSharp.resize.src}
                          alt={speaker.name.name}
                        />
                      </div>
                    )}
                    <h1>
                      {speaker.name.name}
                      <br />
                      {speaker.name.origional_name}
                    </h1>
                    {speaker.job && (
                      <h2>
                        {speaker.job.corp}
                        <br />
                        {speaker.job.job_title}
                      </h2>
                    )}
                  </div>
                </div>
                {content}
              </div>
            </Modal>
          )
        } else {
          return (
            <Layout>
              <SEO
                title={
                  speaker.name.name &&
                  speaker.name.name.replace(/(?:\r\n|\r|\n)/g, " ")
                }
                description={
                  speaker.description &&
                  speaker.description.replace(/(?:\r\n|\r|\n)/g, " ")
                }
                image={
                  speaker.og_image &&
                  speaker.og_image.childImageSharp.original.src
                }
              />
              <div className={[style.sectionWrap, style.page].join(" ")}>
                <div
                  className={style.head}
                  style={{
                    paddingTop: 80,
                    backgroundImage: "url(/images/header.speaker.svg)",
                  }}
                >
                  <div className={style.speaker}>
                    {speaker.avatar && (
                      <div className={style.avatar}>
                        <img
                          src={speaker.avatar.childImageSharp.resize.src}
                          alt={speaker.name.name}
                        />
                      </div>
                    )}
                    <h1>
                      {speaker.name.name}
                      <br />
                      {speaker.name.origional_name}
                    </h1>
                    <h2>
                      {speaker.job && speaker.job.corp}
                      <br />
                      {speaker.job && speaker.job.job_title}
                    </h2>
                  </div>

                  <a
                    className={style.share}
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(
                      props.data.site.siteMetadata.siteUrl +
                        props.location.pathname
                    )}`}
                    rel="noreferrer"
                    target="_blank"
                    onClick={e => {
                      if (
                        share(
                          section.title,
                          section.description,
                          props.data.site.siteMetadata.siteUrl +
                            props.location.pathname
                        )
                      ) {
                        e.preventDefault()
                      }
                    }}
                  >
                    <svg
                      width="23px"
                      height="21px"
                      viewBox="0 0 23 21"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        id="Page-1"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <g
                          id="講者_web_pop"
                          transform="translate(-527.000000, -937.000000)"
                          fillRule="nonzero"
                        >
                          <g
                            id="Group-18"
                            transform="translate(0.000000, -94.000000)"
                          >
                            <g
                              id="fa-solid:share"
                              transform="translate(527.000000, 1030.000000)"
                            >
                              <g
                                id="Icon"
                                transform="translate(0.000000, 1.000000)"
                                fill="#FFFFFF"
                              >
                                <path
                                  d="M22.6267441,7.55026325 L14.7203145,0.774437415 C14.028248,0.18127123 12.9375,0.662803584 12.9375,1.58422852 L12.9375,5.15316746 C5.72174414,5.23515413 0,6.67038893 0,13.4569591 C0,16.1961341 1.77805273,18.9097635 3.74347461,20.3285029 C4.35679297,20.7712487 5.23088281,20.2155762 5.00474609,19.4978919 C2.96780859,13.0328932 5.97088086,11.3165676 12.9375,11.2171047 L12.9375,15.1365489 C12.9375,16.0594005 14.0291016,16.5387929 14.7203145,15.94634 L22.6267441,9.16984545 C23.1240742,8.74355044 23.124748,7.97713782 22.6267441,7.55026325 Z"
                                  id="Icon-Path"
                                ></path>
                              </g>
                              <rect
                                id="ViewBox"
                                x="0"
                                y="0"
                                width="23"
                                height="23"
                              ></rect>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </a>
                </div>
                {content}
              </div>
            </Layout>
          )
        }
      }}
    </ModalRoutingContext.Consumer>
  )
}

export default Section

export const query = graphql`
  query SpeakerPageQuery($slug: String!) {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    allStrapiWriting(filter: { key: { glob: "speaker*" } }) {
      nodes {
        key
        writing
      }
    }
    allStrapiSpeaker(
      filter: { slug: { eq: $slug } }
      sort: { order: ASC, fields: order }
    ) {
      nodes {
        avatar {
          childImageSharp {
            resize(width: 320, height: 320) {
              src
            }
          }
        }
        id
        speakerPage: gatsbyPath(filePath: "/speaker/{StrapiSpeaker.slug}")
        job {
          corp
          id
          job_title
        }
        name {
          id
          name
          origional_name
        }
        description
        order
        og_image {
          childImageSharp {
            original {
              src
            }
          }
        }
        sessions {
          start_time
          end_time
          id
          name
          location
          description
          tag {
            tag
          }
        }
        slug
      }
    }
  }
`
